module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-container"
  }, [_c('div', {
    staticClass: "layout-canvas-wrap"
  }, [_c('div', {
    staticClass: "layout-canvas"
  }, [(!_vm.fullscreen) ? _c('div', {
    staticClass: "row expanded logo"
  }, [_c('partials-header')], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)]), _vm._v(" "), _c('partials-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4053cee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/LayoutSecured.vue
// module id = 490
// module chunks = 2